import React from 'react';
import { Paper, Group, Box, Text, Badge, ActionIcon, Tooltip } from '@mantine/core';
import { IconCircleCheck, IconTrash } from '@tabler/icons-react';

export default function CompletedScenarioCard({ scenario, onRemove, onNavigatePhase, onEdit }) {
  const agentsCount = Array.isArray(scenario.mappedAgents) ? scenario.mappedAgents.length : 0;
  const attrsCount = Object.keys(scenario.attributes || {}).length;
  const attackCount = Object.keys(scenario.completedAttackSurface || {}).length;
  const impactCount = Object.keys(scenario.completedImpact || {}).length;
  const actionsCount = Array.isArray(scenario.controls) ? scenario.controls.length : 0;

  return (
    <Paper withBorder p="lg" radius="md" onClick={() => onNavigatePhase?.(scenario.id, 'summary')} sx={(t) => ({
      borderColor: t.colors.green[4], backgroundColor: t.white, borderWidth: 2,
      transition: 'all 0.2s ease', '&:hover': { boxShadow: t.shadows.sm },
    })}>
      <Group justify="space-between" align="center">
        <Group gap="md" style={{ flex: 1 }}>
          <IconCircleCheck size={24} style={{ color: '#40c057', flexShrink: 0, marginTop: 2 }} />
          <Box style={{ flex: 1 }}>
            <Text size="md" fw={600} c="dark.7">{scenario.name}</Text>
            <Badge size="sm" variant="light" color="green" radius="sm" mt={4}>Evaluated</Badge>
          </Box>
        </Group>
        <Group gap={6} wrap="wrap">
          <Tooltip label="Threat agents" withArrow>
            <Badge variant="light" size="xs" color="blue" onClick={() => onNavigatePhase?.(scenario.id, 'agent-mapping')} sx={{ cursor: 'pointer' }}>
              Agents: {agentsCount}
            </Badge>
          </Tooltip>
          <Tooltip label="Scenario attributes" withArrow>
            <Badge variant="light" size="xs" color="gray" onClick={() => onNavigatePhase?.(scenario.id, 'attributes')} sx={{ cursor: 'pointer' }}>
              Attributes: {attrsCount}
            </Badge>
          </Tooltip>
          <Tooltip label="Attack surface" withArrow>
            <Badge variant="light" size="xs" color="orange" onClick={() => onNavigatePhase?.(scenario.id, 'attack-surface')} sx={{ cursor: 'pointer' }}>
              Attack: {attackCount}
            </Badge>
          </Tooltip>
          <Tooltip label="Impact assessment" withArrow>
            <Badge variant="light" size="xs" color="red" onClick={() => onNavigatePhase?.(scenario.id, 'impact')} sx={{ cursor: 'pointer' }}>
              Impact: {impactCount}
            </Badge>
          </Tooltip>
          <Tooltip label="Mitigating actions" withArrow>
            <Badge variant="light" size="xs" color="green" onClick={() => onNavigatePhase?.(scenario.id, 'action-plan')} sx={{ cursor: 'pointer' }}>
              Actions: {actionsCount}
            </Badge>
          </Tooltip>
          <Badge variant="light" size="xs" color="gray" onClick={(e) => { e.stopPropagation(); onEdit?.(scenario.id); }} sx={{ cursor: 'pointer' }}>
            Edit
          </Badge>
          <ActionIcon size="lg" variant="subtle" color="red" onClick={(e) => { e.stopPropagation(); onRemove(scenario.id); }} sx={(t) => ({ '&:hover': { background: t.colors.red[0] } })}>
            <IconTrash size={18} />
          </ActionIcon>
        </Group>
      </Group>
    </Paper>
  );
}